enum Environment {
  Development = 'dev',
  Production = 'production',
  Ironman = 'iro',
  Staging = 'stg',
}

export default Environment
